'use client';

import { useEffect, useState } from 'react';
import { NotificationBellButton } from './NotoficationBellButton';

export function NotoficationBellButtonClientWrapper() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  if (!show) {
    return null;
  }

  return <NotificationBellButton />;
}
